import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import ProductList from './pages/ProductList';
import Start from './pages/Start';
import NewProduct from './pages/NewProduct';
import Login from './pages/Login';
import { ProtectedRoute, useAuth } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import Unauthorized from './pages/Unauthorized';
import Settings from './pages/Settings';
import Orders from './pages/Orders';
import Analytics from './pages/Analytics';
import SessionTimer from './common/components/SessionTimer';
import UserProfile from './common/components/UserProfile';
import YesNoPopup from './common/components/YesNoPopup';

function App() {
  const { token, logout } = useAuth();
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  const handleLogout = () => {
    logout();
    setShowLogoutPopup(false);
  };

  const handleCancelLogout = () => {
    setShowLogoutPopup(false);
  };

  return (
    <DataProvider>
        <Router>
          <div className="App">
            <header className="App-header">
              <div className="layout">
              {( token && <nav className="left-nav">
                  <UserProfile />
                  <ul>
                    <li><NavLink to="/" className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Home</NavLink></li>
                    <li><NavLink to="/items" className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Products</NavLink></li>
                    <li><NavLink to="/orders" className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Orders</NavLink></li>
                    <li><NavLink to="/settings" className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Settings</NavLink></li>
                    <li><NavLink to="/analytics" className={({ isActive }) => isActive ? "nav-button active" : "nav-button"}>Analytics</NavLink></li>
                    <li style={{ marginTop: '20px', cursor: 'pointer' }}>
                      <a href='/' onClick={(e) => { e.preventDefault(); setShowLogoutPopup(true); }} className="nav-button">Sign Out</a>
                    </li>
                    <SessionTimer />
                  </ul>
                </nav> )}
                <main className={!token ? 'login-page' : 'content'}>
                  {showLogoutPopup && (
                    <YesNoPopup
                      message="Are you sure you want to logout?"
                      handleYes={handleLogout}
                      handleNo={handleCancelLogout}
                    />
                  )}
                  <Routes>
                    <Route path="/login" element={<Login message='Welcome back!'/>} />
                    <Route path="/unauthorized" element={<Unauthorized/>} />
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute>
                          <Start />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/items"
                      element={
                        <ProtectedRoute>
                          <ProductList />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/items/new"
                      element={
                        <ProtectedRoute>
                          <NewProduct />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/items/edit/:id"
                      element={
                        <ProtectedRoute>
                          <NewProduct />
                        </ProtectedRoute>
                      }
                    />
                    <Route 
                      path='/settings'
                      element={
                        <ProtectedRoute>
                          <Settings />
                        </ProtectedRoute>
                      }
                      />
                    <Route 
                      path='/orders'
                      element={
                        <ProtectedRoute>
                          <Orders />
                        </ProtectedRoute>
                      }
                      />
                    <Route 
                      path='/analytics'
                      element={
                        <ProtectedRoute>
                          <Analytics />
                        </ProtectedRoute>
                      }
                      />
                  </Routes>
                </main>
              </div>
            </header>
          </div>
        </Router>
    </DataProvider>
  );
}

export default App;
